import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';


@Injectable({
  providedIn: 'root'
})
export class UsiService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(private handler: HttpBackend, private http: HttpClient, private storageService: LocalStorageService) {
    super();
    this.httpClient = new HttpClient(handler);

   }

   handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
  //  window.alert(errorMessage);
  console.log("Error:",errorMessage);
    return throwError(errorMessage);
  }

   // Create UsiTemplates
   createUsiTemplates(user: Object): Observable<Object> {
    console.log("In createusiTemplates method, UsiTemplates: ", user);
    return this.http.post(`${environment.apiUrl}/usiTemplates`, user).pipe(catchError(this.handleError));
  }

    // Get usiTemplates by Id Get
    getUsiTemplates(id: number): Observable<Object> {
      return this.http.get(`${environment.apiUrl}/usiTemplates/${id}`).pipe(catchError(this.handleError));
    }
  
     //Delete usiTemplates by Id Delete
    deleteUsiTemplates(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/usiTemplates/${id}`).pipe(catchError(this.handleError));
  }

   //Update usiTemplates by Id Put
   updateUsiTemplates(user: Object,id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/usiTemplates/${id}`, user).pipe(catchError(this.handleError));
  }

   //Get All usiTemplates by Id Get
   getAllUsiTemplates(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/usiTemplates`).pipe(catchError(this.handleError));
  }

  
}
